import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type DayforceWebhook = {
  id: number
  agencyId: string
  status: string
  attempts: number
  payload: string
  createdAt: string
  updatedAt: string
}

export type DayforceWebhooks = DayforceWebhook[]

type ListDayforceWebhooksRequest = {
  page: number
  pageSize: number
  agencyId?: string[] | null
  eventType?: string[] | null
  status?: string[] | null
}

export type ListDayforceWebhooksResponse = {
  items: DayforceWebhooks
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

export const listDayforceWebhooks = async (
  request: ListDayforceWebhooksRequest
): Promise<ListDayforceWebhooksResponse> => {
  const params: Record<string, string | number | string[] | null | undefined> =
    {
      page: request.page,
      page_size: request.pageSize,
      agency_id: request.agencyId,
      event_type: request.eventType,
      status: request.status,
    }

  const response = await api.get<ListDayforceWebhooksResponse>(
    '/admin/dayforce/webhooks',
    { params, paramsSerializer: queryParamSerializer }
  )
  return response.data
}
